import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "list", "template"]

  add() {
    const value = this.inputTarget.value.trim()
    if (!value) return
    if (!this.inputTarget.checkValidity()) {
      window.materialValidator?.showError(this.inputTarget)
      return
    }

    const chip = this.templateTarget.content.firstElementChild.cloneNode(true)
    chip.querySelector('[data-chip-input-target="label"]').textContent = value
    chip.querySelector('[data-chip-input-target="hidden"]').value = value

    this.listTarget.appendChild(chip)
    this.inputTarget.value = ""
    window.materialValidator?.hideFieldError(this.inputTarget)
  }

  addOnEnter(event) {
    event.preventDefault()
    this.add()
  }

  remove(event) {
    event.currentTarget.closest(".state-tag").remove()
  }
}
